import { useFormContext } from 'react-hook-form';

import { useCloverPaymentForm } from '@getbento/payments/providers/CloverPaymentFormProvider';
import { useLoadingSpinner } from 'reservations/base/providers/LoadingSpinnerProvider';
import { BaseChecklessPaymentsButton } from 'reservations/checklessPayments/components/BaseChecklessPaymentsButton';
import { useEnrollChecklessMutation } from 'reservations/checklessPayments/queries/useEnrollChecklessMutation';

interface Props {
  disabled?: boolean;
  handleClick: () => void;
  handleSaveFailed: () => void;
}

export const SaveChecklessButton = ({
  handleClick,
  handleSaveFailed = () => {},
  disabled = false
}: Props) => {
  const { handleSubmit: handleSubmitBookingForm } = useFormContext();
  const { handleIsLoading, handleHasLoaded } = useLoadingSpinner();
  const handlePaymentForm = useCloverPaymentForm()?.handlePaymentForm;

  const handleSuccess = () => {
    handleClick();
    handleHasLoaded();
  };

  const enrollChecklessMutation = useEnrollChecklessMutation(
    handleSuccess,
    handleSaveFailed
  );

  const onSubmit = (data: Record<string, any>) => {
    enrollChecklessMutation.mutate(data);
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    handleIsLoading('');
    await handlePaymentForm?.();
    return handleSubmitBookingForm(onSubmit, handleHasLoaded)(event);
  };

  return (
    <BaseChecklessPaymentsButton
      buttonText="SAVE"
      handleClick={handleSubmit}
      disabled={disabled}
      dataTestId="save-checkless-button"
    />
  );
};
